import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {PaymentModeState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class PaymentModeQuery extends QueryEntity<PaymentModeState> {

  constructor(protected store: Store) {
    super(store);
  }

}
